import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { checkAgoricProof } from "./actions";
import { getProof } from "../solana-proof/actions";

import { AgoricProofState } from "./types";
import { LOCAL_STORAGE_KEYS } from "configs";

export const applyAgoricToken = (key: string, token: AgoricProofState["agoricProofToken"]) => {
  if (token) {
    localStorage.setItem(key, token);
  } else {
    localStorage.removeItem(key);
  }

  return token;
};

const initialState: AgoricProofState = {
  pending: false,
  error: null,
  agoricProofToken: null,
};

const agoricSlice = createSlice({
  name: "agoricProof",
  initialState: {
    ...initialState,
    agoricProofToken: localStorage.getItem(LOCAL_STORAGE_KEYS.agoricToken),
  },
  reducers: {
    resetAgoricProofState: () => {
      applyAgoricToken(LOCAL_STORAGE_KEYS.agoricToken, null);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.agoricWallet);
      return initialState;
    },
    setAgoricPending: (state, action: PayloadAction<boolean>) => {
      state.pending = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      // get proof payload
      .addCase(getProof.pending, state => {
        state.pending = true;
      })
      .addCase(getProof.fulfilled, (state, action) => {
        state.agoricPayload = action.payload;
        state.error = null;
        state.pending = false;
      })
      .addCase(getProof.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
          state.pending = false;
        }
      })
      // check agoric proof
      .addCase(checkAgoricProof.pending, state => {
        state.pending = true;
      })
      .addCase(checkAgoricProof.fulfilled, (state, action) => {
        const { token } = action.payload;
        state.error = null;
        state.agoricProofToken = applyAgoricToken(LOCAL_STORAGE_KEYS.agoricToken, token);
        state.pending = false;
      })
      .addCase(checkAgoricProof.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
          state.agoricProofToken = applyAgoricToken(LOCAL_STORAGE_KEYS.agoricToken, null);
          state.pending = false;
        }
      });
  },
});

export const { resetAgoricProofState, setAgoricPending } = agoricSlice.actions;

export default agoricSlice;
